import { render, staticRenderFns } from "./PersonTreatmentHistory.vue?vue&type=template&id=4d5b3d44&"
import script from "./PersonTreatmentHistory.vue?vue&type=script&lang=js&"
export * from "./PersonTreatmentHistory.vue?vue&type=script&lang=js&"
import style0 from "./PersonTreatmentHistory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports